import { toast } from "react-toastify";

export const handleCopy = (text: string, notificationText?: string) =>
  toast.promise(navigator.clipboard.writeText(text), {
    pending: "Copying...",
    success: notificationText ?? "Copied to clipboard",
    error: "Cannot copy to clipboard"
  });
